import { User } from 'connex-cds';
import { PERMISSIONS } from './permissions';

const config = [
  {
    id: 'option1',
    labelStringId: 'option1',
    path: '/option1',
    icon: 'fa-thin fa-users',
    permission: PERMISSIONS.PERM_1,
  },
  {
    id: 'option2',
    labelStringId: 'option2',
    path: '/option2',
    icon: 'fa-thin fa-gear',
    permission: PERMISSIONS.PERM_1,
  },
  {
    id: 'option3',
    labelStringId: 'option3',
    path: '/option3',
    icon: 'fa-thin fa-gear',
    permission: PERMISSIONS.PERM_2,
  },
];

export const useMenuConfig = () => {
  const { has } = User.useHasPermission();

  return config.reduce((acc, value) => {
    const { permission, ...menuConfig } = value;
    if (has(permission)) {
      acc.push(menuConfig);
    }
    return acc;
  }, []);
};
